import styled from '@emotion/styled';
import {
  CONNECTOR_WRAPPER_WIDTH,
  CONNECTOR_THICKNESS,
  CONNECTOR_COLOR,
  HIGHLIGHTED_CONNECTOR_COLOR,
} from './styleConstants';
import {
  CARD_HEIGHT,
  CARD_MARGIN_BOTTOM,
} from '../../PerspectiveCard/styleConstants';

type HigherCardConnectorProps = {
  index: number;
  parentCardIndex: number;
  highlighted: boolean;
};

const HigherCardConnector = styled('div')<HigherCardConnectorProps>(
  ({ index, parentCardIndex, highlighted }) => ({
    position: 'absolute',
    top:
      (index + 1) * CARD_HEIGHT +
      index * CARD_MARGIN_BOTTOM -
      CARD_HEIGHT / 2 -
      CONNECTOR_THICKNESS / 2,
    left: 0,
    width: '100%',
    height:
      (parentCardIndex - index) * CARD_HEIGHT +
      (parentCardIndex - index) * CARD_MARGIN_BOTTOM +
      CONNECTOR_THICKNESS,
    boxSizing: 'border-box',
    zIndex: highlighted ? 2 : 1,
    '::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      width: `calc(50% + ${CONNECTOR_THICKNESS / 2}px)`,
      height: '50%',
      boxSizing: 'border-box',
      borderRight: `${CONNECTOR_THICKNESS}px solid ${CONNECTOR_COLOR}`,
      borderBottom: `${CONNECTOR_THICKNESS}px solid ${CONNECTOR_COLOR}`,
      borderBottomRightRadius: CONNECTOR_WRAPPER_WIDTH / 2,
      borderColor: highlighted ? HIGHLIGHTED_CONNECTOR_COLOR : undefined,
    },
    '::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      width: `calc(50% + ${CONNECTOR_THICKNESS / 2}px)`,
      height: '50%',
      boxSizing: 'border-box',
      borderLeft: `${CONNECTOR_THICKNESS}px solid ${CONNECTOR_COLOR}`,
      borderTop: `${CONNECTOR_THICKNESS}px solid ${CONNECTOR_COLOR}`,
      borderTopLeftRadius: CONNECTOR_WRAPPER_WIDTH / 2,
      borderColor: highlighted ? HIGHLIGHTED_CONNECTOR_COLOR : undefined,
    },
  }),
);

export default HigherCardConnector;
